module.exports = __webpack_public_path__ + "img/coverimg.d2269f5e.png";